import React, { useEffect, useState } from 'react'
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import PreparingOrderCard from "./components/preparingOrderCard/PreparingOrderCard2";
import CompleteOrderCard from "./components/completeOrderCard/CompleteOrderCard2";
import AdvertisementCard from "./components/advertisementCard/AdvertisementCard";
import io from "socket.io-client";
import { switch_to_billing_screen } from '../Sales/Billing/newBillingSlice';
import { setHideHeader } from "./kotTokenDisplaySlice";
import { useDispatch, useSelector } from 'react-redux';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useNavigate } from 'react-router-dom';
import { getTokenDisplayAPI } from './tokenDisplayApi';
import axios from 'axios';
import AlertMessage from '../FloorManagement/components/alertMessage/AlertMessage';
import { setAlertMessage } from "./components/advertisementCard/advertisementSlice";
import ThalipeLogoBlk from '../../../Assets/Images/ThalipeLogoBlack.png';
import { getCurrentTime } from "../../../Js/Date";

import {
  setFontColor,
  setBackgroundColor,
  setReadyBgColor,
  setPrepareBg,
  setPrepareColumnBgEnabled,
  setReadyColumnBgEnabled,
  setPrepareColumnBgOpacity,
  setReadyColumnBgOpacity,
  setPrepareColumnBgMediaIds,
  setReadyColumnBgMediaIds,
  setColumnBgIntervalMs,
} from "./kotTokenDisplaySlice";

const KotTokenDisplay2 = () => {
   const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginResponse = useSelector((state) => state.loginResponseSlice.value);
  const { kotTokenData, showHeaderDateTime, enableNewsScrollMedia, newsScrollItems, tickerAnimationType } = useSelector((state) => state.kotTokenDisplaySlice);
  const { alertMessage } = useSelector((state) => state.advertisementSlice);

  const [displayMode, setDisplayMode] = useState(0); // 0 = all, 1 = no ads, 2 = only ads
  console.log(kotTokenData);

  useEffect(() => {
    dispatch(switch_to_billing_screen({ billingBoolean: true }));
  }, []);

  const [nowDateText, setNowDateText] = useState("");
  const [nowTimeText, setNowTimeText] = useState("");
  useEffect(() => {
    if (!showHeaderDateTime) return;
    const update = () => {
      const d = new Date();
      const formattedDate = d.toLocaleDateString(undefined, {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
      const formattedTime = d.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      setNowDateText(formattedDate);
      setNowTimeText(formattedTime);
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [showHeaderDateTime]);

  const tickerItems = Array.isArray(newsScrollItems)
    ? newsScrollItems.map((x) => String(x || "").trim()).filter(Boolean)
    : [];

  const [flashTickerIndex, setFlashTickerIndex] = useState(0);
  useEffect(() => {
    if (!enableNewsScrollMedia) return;
    if (tickerAnimationType !== "flash") return;
    if (tickerItems.length === 0) return;
    setFlashTickerIndex(0);
    const interval = setInterval(() => {
      setFlashTickerIndex((prev) => (prev + 1) % tickerItems.length);
    }, 2200);
    return () => clearInterval(interval);
  }, [enableNewsScrollMedia, tickerAnimationType, tickerItems.length]);

  useEffect(() => {
    const socket = io(axios.defaults.baseURL, {
      path: "/socket.io/",
      reconnection: true,
      transports: ["websocket"],
      reconnectionAttempts: 5,
    });

    socket.on("connect", () => {
      if (loginResponse?.data?._id && loginResponse?.branchPk) {
        socket.emit(
          "setUsername",
          loginResponse?.data?._id,
          loginResponse?.branchPk
        );
      }
    });

    if (!kotTokenData) {
      getTokenDisplayAPI({
        body: { branchId: loginResponse?.branchPk },
      });
    }

    const updateKotList = () => {
      getTokenDisplayAPI({
        body: { branchId: loginResponse?.branchPk },
      });
    };

    socket.on("toKotCookStatus", updateKotList);
    socket.on("toKotCompleteStatus", updateKotList);
    socket.on("toKotResetStatus", updateKotList);
    socket.on("toKotDeliveryStatus", updateKotList);

    return () => {
      socket.disconnect();
      socket.off("connect");
      socket.off("toKotCookStatus");
      socket.off("toKotCompleteStatus");
      socket.off("toKotResetStatus");
      socket.off("toKotDeliveryStatus");
    };
  }, [loginResponse, kotTokenData]);

  const setAlertMessageHandler = () => {
    if (alertMessage !== null) {
      dispatch(setAlertMessage(null));
    }
  };
  useEffect(() => {
    dispatch(setHideHeader(true));
  }, []);

  const toggleDisplayMode = () => {
    setDisplayMode((prev) => (prev + 1) % 3);
  };
  // const handleFontSizeChange = (newSize) => {
  //   setFontSize(newSize);
  // };
  useEffect(() => {
    const savedFontColor = localStorage.getItem("fontColor");
    const savedBackgroundColor = localStorage.getItem("backgroundColor");
    const savedPrepareBgColor = localStorage.getItem("prepareBgColor");
    const savedReadyBgColor = localStorage.getItem("readyBgColor");

    const savedPrepareColumnBgEnabled = localStorage.getItem("tokenDisplay.prepareColumnBgEnabled");
    const savedReadyColumnBgEnabled = localStorage.getItem("tokenDisplay.readyColumnBgEnabled");
    const savedPrepareColumnBgOpacity = localStorage.getItem("tokenDisplay.prepareColumnBgOpacity");
    const savedReadyColumnBgOpacity = localStorage.getItem("tokenDisplay.readyColumnBgOpacity");
    const savedPrepareColumnBgMediaIds = localStorage.getItem("tokenDisplay.prepareColumnBgMediaIds");
    const savedReadyColumnBgMediaIds = localStorage.getItem("tokenDisplay.readyColumnBgMediaIds");
    const savedColumnBgIntervalMs = localStorage.getItem("tokenDisplay.columnBgIntervalMs");

    if (savedFontColor) dispatch(setFontColor(savedFontColor));
    if (savedBackgroundColor)
      dispatch(setBackgroundColor(savedBackgroundColor));
    if (savedPrepareBgColor) dispatch(setPrepareBg(savedPrepareBgColor));
    if (savedReadyBgColor) dispatch(setReadyBgColor(savedReadyBgColor));

    if (savedPrepareColumnBgEnabled != null) dispatch(setPrepareColumnBgEnabled(savedPrepareColumnBgEnabled === "true"));
    if (savedReadyColumnBgEnabled != null) dispatch(setReadyColumnBgEnabled(savedReadyColumnBgEnabled === "true"));
    if (savedPrepareColumnBgOpacity != null) dispatch(setPrepareColumnBgOpacity(Number(savedPrepareColumnBgOpacity)));
    if (savedReadyColumnBgOpacity != null) dispatch(setReadyColumnBgOpacity(Number(savedReadyColumnBgOpacity)));
    if (savedPrepareColumnBgMediaIds) {
      try {
        dispatch(setPrepareColumnBgMediaIds(JSON.parse(savedPrepareColumnBgMediaIds)));
      } catch (_) {}
    }
    if (savedReadyColumnBgMediaIds) {
      try {
        dispatch(setReadyColumnBgMediaIds(JSON.parse(savedReadyColumnBgMediaIds)));
      } catch (_) {}
    }
    if (savedColumnBgIntervalMs != null) dispatch(setColumnBgIntervalMs(Number(savedColumnBgIntervalMs)));
  }, []);
  return (
     <div className="kot-token-display-container">
      <div className="toggle-btn-container">
        <button className="toggle-view-btn" onClick={toggleDisplayMode}>
          {displayMode === 0 && <ArrowForwardIosIcon color="error" />}
          {displayMode === 1 && <FullscreenIcon color="error" />}
          {displayMode === 2 && <FullscreenExitIcon color="error" />}
        </button>

        <div className="token-header-inline">
          <img style={{width:"13vh"}} src={ThalipeLogoBlk} alt="Thalipe logo" />
          {showHeaderDateTime && (
            <div className="token-header-datetime">
              <span className="token-header-date">
                <span className="token-header-today">TODAY</span>
                <span className="token-header-date-text">{nowDateText}</span>
              </span>
              <span className="token-header-time">{nowTimeText || getCurrentTime()}</span>
            </div>
          )}
          {enableNewsScrollMedia && tickerItems.length > 0 && (
            <div className="token-header-ticker">
              {tickerAnimationType === "flash" ? (
                <div className="token-header-ticker-flash" aria-label="news ticker">
                  <span className="token-header-ticker-item token-header-ticker-item-flash">
                    <span className="token-header-ticker-chef" aria-hidden="true">👨‍🍳</span>
                    <span className="token-header-ticker-text">
                      {tickerItems[flashTickerIndex]}
                    </span>
                  </span>
                </div>
              ) : (
                <div
                  className={`token-header-ticker-inner token-header-ticker-anim-${tickerAnimationType || "scroll"}`}
                  aria-label="news ticker"
                >
                  {tickerItems.map((text, idx) => (
                    <span
                      className={`token-header-ticker-item${
                        tickerAnimationType === "blast" ? " token-header-ticker-item-blast" : ""
                      }`}
                      key={`${idx}-${text}`}
                    >
                      <span className="token-header-ticker-chef" aria-hidden="true">👨‍🍳</span>
                      <span className="token-header-ticker-text">{text}</span>
                      <span className="token-header-ticker-sep" aria-hidden="true">•</span>
                    </span>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        {
          <div className="token-expand-btn close-adv">
            <div>
              <button
                onClick={() => {
                  dispatch(switch_to_billing_screen({ billingBoolean: false }));
                  navigate("/userdashboard/dashboardhome");
                  dispatch(setHideHeader(false));
                }}
              >
                <HighlightOffIcon color="error" />
              </button>
              
            </div>
          </div>
        }
       
      </div>
       <div className="token-display-body">
        {displayMode !== 2 && (
          <PreparingOrderCard  displayMode={displayMode} />
        )}
         {displayMode !== 2 && (
          <CompleteOrderCard  displayMode={displayMode}/>
        )}
        {displayMode !== 1 && (
          <AdvertisementCard toggleDisplayMode={toggleDisplayMode} />
        )}
        <AlertMessage
          status={alertMessage?.status}
          alertMessage={alertMessage?.message}
          setApiAlertMessage={setAlertMessageHandler}
        />
      </div>
      </div>
  )
}

export default KotTokenDisplay2